import { validator } from "@/utils/validator";

export const languageTestLevelSchema = validator.object().shape({
  level: validator.string().trim().emptyToNull().label("レベル").required(),
});

export const languageTestSchema = validator.object().shape({
  testName: validator.string().trim().emptyToNull().label("試験名（日本語）").required(),
  description: validator.string().trim().emptyToNull().label("説明").notRequired(),
  levels: validator.array().of(languageTestLevelSchema).label("レベル").required(),
});
